import { FC } from 'react'
import { usePrefectureLinks } from './dependencies'
import { css } from '@emotion/react'
import { mq } from '@lifedot/styles/mediaQuery'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import { PrefectureLinksList } from '@/components/PrefectureLinksList/PrefectureLinksList'

const styles = {
  accordions: css({
    display: 'none',
    p: {
      margin: 0
    },
    [mq('sp')]: {
      display: 'block',
      width: '100%'
    }
  }),
  title: css({
    backgroundColor: palette.main02,
    padding: '8px 12px',
    fontWeight: 'bold',
    color: palette.white
  }),
  region: css({
    marginTop: 8
  })
}

interface InnerAccordionsProps {
  choiceCode?: string
}

export const InnerAccordions: FC<InnerAccordionsProps> = ({ choiceCode }) => {
  const [disables, condition] = usePrefectureLinks(choiceCode)

  return (
    <div css={styles.accordions}>
      <p css={[typography.headingS, styles.title]}>
        {condition?.name ? `${condition.name}を探す` : `エリアから探す`}
      </p>
      <div css={styles.region}>
        <PrefectureLinksList {...{ disables, condition }} />
      </div>
    </div>
  )
}
